@if (user$ | async; as user) {
<div class="sidebar-anchor" [ngClass]="{ expanded }">
  <nav class="sidebar" [ngClass]="{ expanded }">
    @if (expanded) {
    <div
      @fadeAnimation
      class="header"
      [ngClass]="{ expandedHeader }"
      (click)="toggleHeader()"
    >
      <gc-icon
        [iconName]="'user'"
        [size]="'medium'"
        [color]="'invert'"
        [ariaLabel]="'User icon'"
        class="header-icon"
      ></gc-icon>
      <div class="header-info">
        <p>{{ user.name }}</p>
        <p>{{ user.group?.name }}</p>
      </div>
      <gc-icon
        [iconName]="'chevronDown'"
        [size]="'medium'"
        [color]="'invert'"
        [ariaLabel]="'chevron'"
        class="header-icon rotatable"
      ></gc-icon>
    </div>
    } @if (expandedHeader) {
    <button @growAnimation (click)="logout()" class="logout-button">
      {{ 'logout' | translate }}
      <gc-icon
        [iconName]="'arrowRightToBracket'"
        [size]="'medium'"
        [color]="'invert'"
        [ariaLabel]="'logout icon'"
        class="logout-icon"
      ></gc-icon>
    </button>
    } @if (expanded) {
    <div @listFadeAnimation class="links">
      @for (link of links; track link; let i = $index) { @if
      (allowToSeeLink(link.requiredRoles)) {
      <a
        [routerLink]="link.url"
        [ngClass]="{ active: i === activeIndex }"
        (click)="toggle(i)"
      >
        <gc-icon
          [iconName]="link.icon"
          [size]="'medium'"
          [color]="'invert'"
          [ariaLabel]="'icon'"
          class="link-icon"
        ></gc-icon>
        {{ link.text }}
      </a>
      } }
    </div>
    }
    <button class="hamburger" [ngClass]="{ expanded }" (click)="toggle()">
      <div class="brgr brgr-1"></div>
      <div class="brgr brgr-2"></div>
      <div class="brgr brgr-3"></div>
    </button>
  </nav>
</div>
}
